"use client";

import { useContext } from "react";

import { ChatHistoryContext } from "../contexts/ChatHistoryContext";

export const useChatHistory = () => {
  const context = useContext(ChatHistoryContext);
  if (!context) {
    throw new Error("useChatHistory must be used within a ChatHistoryProvider");
  }

  return context;
};
